import type { FC, SVGProps } from 'react';

const InfoListIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5H20.25C20.6642 4.5 21 4.83579 21 5.25C21 5.66421 20.6642 6 20.25 6H3.75C3.33579 6 3 5.66421 3 5.25ZM3 11.25C3 10.8358 3.33579 10.5 3.75 10.5H17.25C19.3211 10.5 21 12.1789 21 14.25C21 16.3211 19.3211 18 17.25 18H15.3107L16.2803 18.9697C16.5732 19.2626 16.5732 19.7374 16.2803 20.0303C15.9874 20.3232 15.5126 20.3232 15.2197 20.0303L12.9697 17.7803C12.6768 17.4874 12.6768 17.0126 12.9697 16.7197L15.2197 14.4697C15.5126 14.1768 15.9874 14.1768 16.2803 14.4697C16.5732 14.7626 16.5732 15.2374 16.2803 15.5303L15.3107 16.5H17.25C18.4926 16.5 19.5 15.4926 19.5 14.25C19.5 13.0074 18.4926 12 17.25 12H3.75C3.33579 12 3 11.6642 3 11.25ZM3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H10.5C10.9142 16.5 11.25 16.8358 11.25 17.25C11.25 17.6642 10.9142 18 10.5 18H3.75C3.33579 18 3 17.6642 3 17.25Z"
      fill="currentColor"
    />
  </svg>
);

export default InfoListIcon;
